var _defs, _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsightsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1280 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f7931e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M873.6,1174.3H87.9c-9,0-16.2-7.3-16.2-16.2V118.6c0-9,7.3-16.2,16.2-16.2h785.7c9,0,16.2,7.3,16.2,16.2v1039.5c0,9-7.3,16.2-16.2,16.2ZM104.2,1141.8h753.2V134.8H104.2v1007Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M748,649.4H213.6c-9,0-16.2-7.3-16.2-16.2v-313.9c0-9,7.3-16.2,16.2-16.2h534.4c9,0,16.2,7.3,16.2,16.2v313.9c0,9-7.3,16.2-16.2,16.2ZM229.8,616.9h501.9v-281.4H229.8v281.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M671.3,757.5h-381c-9,0-16.2-7.3-16.2-16.2s7.3-16.2,16.2-16.2h381c9,0,16.2,7.3,16.2,16.2s-7.3,16.2-16.2,16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M671.3,865.6h-381c-9,0-16.2-7.3-16.2-16.2s7.3-16.2,16.2-16.2h381c9,0,16.2,7.3,16.2,16.2s-7.3,16.2-16.2,16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M671.3,973.7h-381c-9,0-16.2-7.3-16.2-16.2s7.3-16.2,16.2-16.2h381c9,0,16.2,7.3,16.2,16.2s-7.3,16.2-16.2,16.2Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1046,1174.3c-5,0-9.7-2.3-12.8-6.2l-57.3-73.4c-2.2-2.8-3.4-6.4-3.4-10V241.4c0-9,7.3-16.2,16.2-16.2h114.6c9,0,16.2,7.3,16.2,16.2v843.2c0,3.6-1.2,7.1-3.4,10l-57.3,73.4c-3.1,3.9-7.8,6.2-12.8,6.2ZM1005,1079.1l41.1,52.6,41.1-52.6V257.7h-82.1v821.4h0ZM1103.3,1084.7h.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1103.3,1042.7h-114.6c-9,0-16.2-7.3-16.2-16.2s7.3-16.2,16.2-16.2h114.6c9,0,16.2,7.3,16.2,16.2s-7.3,16.2-16.2,16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1187.7,654.6c-9,0-16.2-7.3-16.2-16.2v-244.3c0-24.8-20.2-45-45-45h-137.7c-9,0-16.2-7.3-16.2-16.2s7.3-16.2,16.2-16.2h137.7c42.7,0,77.5,34.8,77.5,77.5v244.3c0,8.9-7.3,16.2-16.2,16.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsIcon);
export default __webpack_public_path__ + "static/media/insights-icon.b2162ac45e71a0ba30e71a9a5e4c83e2.svg";
export { ForwardRef as ReactComponent };